import type { ReactNode, MouseEvent } from 'react';
import styles from './HoverPillButton.module.css';

type HoverPillButtonVariant = 'default' | 'danger';

interface HoverPillButtonProps {
  variant?: HoverPillButtonVariant;
  label: string;
  icon: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
}

export default function HoverPillButton({
  variant = 'default',
  label,
  icon,
  onClick,
  disabled,
  ariaLabel,
  className,
}: HoverPillButtonProps) {
  const variantClass = variant === 'danger' ? styles.danger : styles.default;

  return (
    <button
      type="button"
      className={`${styles.pill} ${variantClass}${disabled ? ` ${styles.disabled}` : ''}${className ? ` ${className}` : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel ?? label}
      data-hover-pill=""
    >
      <span className={styles.label} data-hover-pill-label="">{label}</span>
      <span className={styles.icon} data-hover-pill-icon="">{icon}</span>
    </button>
  );
}
